export type ContractAddress = `0x${string}`

export const Contracts: Record<string, Record<string, ContractAddress | Record<string, ContractAddress>>> = {
  gains: {
    "1": process.env.REACT_APP_GAINS_TOKEN_CONTRACT_ADDRESS_ETHEREUM as ContractAddress,
    "11155111": process.env.REACT_APP_GAINS_TOKEN_CONTRACT_ADDRESS_ETHEREUM_TESTNET as ContractAddress,
    "56": process.env.REACT_APP_GAINS_TOKEN_CONTRACT_ADDRESS_BINANCE as ContractAddress,
    "97": process.env.REACT_APP_GAINS_TOKEN_CONTRACT_ADDRESS_BINANCE_TESTNET as ContractAddress,
  },
  lockFactory: { // versioning needed for lockFactory addresses
    "1": {
      "1": process.env.REACT_APP_GAINS_LOCK_FACTORY_ETHEREUM_V1 as ContractAddress,
      "11155111": process.env.REACT_APP_GAINS_LOCK_FACTORY_ETHEREUM_V1 as ContractAddress,
      "56": process.env.REACT_APP_GAINS_LOCK_FACTORY_BINANCE_V1 as ContractAddress,
      "97": process.env.REACT_APP_GAINS_LOCK_FACTORY_BINANCE_V1 as ContractAddress,
    },
    "2": {
      "1": process.env.REACT_APP_GAINS_LOCK_FACTORY_ETHEREUM_V2 as ContractAddress,
      "11155111": process.env.REACT_APP_GAINS_LOCK_FACTORY_ETHEREUM_V2 as ContractAddress,
      "56": process.env.REACT_APP_GAINS_LOCK_FACTORY_BINANCE_V2 as ContractAddress,
      "97": process.env.REACT_APP_GAINS_LOCK_FACTORY_BINANCE_V2 as ContractAddress,
    },
  },
  proxy: {
    "1": process.env.REACT_APP_CONTRIBUTION_PROXY_ETHEREUM as ContractAddress,
    "11155111": process.env.REACT_APP_CONTRIBUTION_PROXY_ETHEREUM_TESTNET as ContractAddress,
    "56": process.env.REACT_APP_CONTRIBUTION_PROXY_BINANCE as ContractAddress,
    "97": process.env.REACT_APP_CONTRIBUTION_PROXY_BINANCE_TESTNET as ContractAddress,
  },
  multicall: {
    "1": process.env.REACT_APP_MULTICALL_CONTRACT_ADDRESS_ETHEREUM as ContractAddress,
    "11155111": process.env.REACT_APP_MULTICALL_CONTRACT_ADDRESS_ETHEREUM_TETSTNET as ContractAddress,
    "56": process.env.REACT_APP_MULTICALL_CONTRACT_ADDRESS_BINANCE as ContractAddress,
    "97": process.env.REACT_APP_MULTICALL_CONTRACT_ADDRESS_BINANCE_TESTNET as ContractAddress,
  },
};
